/**
 * 缓存说明:事件缓存
 */
import vm from '@/cache/storeTools.js'
import eventApi from '@/components/api/eventApi.js'

var basestate = {
	eventTypes: undefined, //已经启用的事件类型列表
	levelMap: {
		0: '消息',
		1: '预警',
		2: '告警'
	},
	stateMap: {
		0: '未处理',
		1: '处理中',
		2: '已处理',
		3: '已确认'
	}
}
var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		searchAllEventTypes(state, getters) {
			if(state.eventTypes == undefined) {
				//获取数据
				store.commit("searchAllEventTypes")
				return []
			}
			return state.eventTypes
		},
		getLevelName(state, getters) {
			//获取事件等级名称
			return level => {
				return state.levelMap[level] ? state.levelMap[level] : '消息'
			}
		},
		getStateName(state, getters) {
			//获取事件状态名称
			return s => {
				return state.stateMap[s]?state.stateMap[s]:'未处理'
			}
		},
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		searchAllEventTypes(state) {
			eventApi.searchAllEventTypes(respon => {
				vm.Vue.set(state, 'eventTypes', respon)
			})
		},
	}
});
//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */